import { RestClient } from "./restClient";
import RestResponse from "@/models/client/RestResponse";
import RequestMethod from "@/models/client/RequestMethod";
import {
  PiiOverrideAudit,
  PiiOverrideConversationSummary,
  RecordPiiOverrideRequest,
} from "@/models/pii/PiiOverride";

export type PiiOverrideServiceType = {
  record: (request: RecordPiiOverrideRequest) => RestResponse<void>;
  getByConversation: (
    conversationId: string
  ) => RestResponse<PiiOverrideAudit[]>;
  /** Batch summaries for one page of the Insights list (avoids per-row GETs). */
  getConversationSummaries: (
    conversationIds: string[]
  ) => RestResponse<PiiOverrideConversationSummary[]>;
};

const piiOverrideServices = (
  client: RestClient,
  path: string
): PiiOverrideServiceType => ({
  record: async (request: RecordPiiOverrideRequest) => {
    return await client.fetch<void>(RequestMethod.POST, path, request);
  },
  getByConversation: async (conversationId: string) => {
    return await client.fetch<PiiOverrideAudit[]>(
      RequestMethod.GET,
      `${path}/conversation/${conversationId}`
    );
  },
  getConversationSummaries: async (conversationIds: string[]) => {
    return await client.fetch<PiiOverrideConversationSummary[]>(
      RequestMethod.POST,
      `${path}/summary`,
      { conversationIds }
    );
  },
});

export default piiOverrideServices;
